import { render, staticRenderFns } from "./OptionalGroup.vue?vue&type=template&id=f04928dc&"
import script from "./OptionalGroup.vue?vue&type=script&lang=ts&"
export * from "./OptionalGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports